/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamQuestion } from './oralExamQuestion';

/**
 * Replace the entire question pool for an oral exam task.
 */
export interface OralExamPoolReplaceRequest {
  questionPool: OralExamQuestion[];
}
